export const AppConst = {
  LOGIN_METHOD: <LOGIN_METHOD> {
    ONLINE: 'ONLINE',
    CORDOVA: 'CORDOVA'
  },
  EVENTS: <EVENTS> {
    LOGIN: 'LOGIN',
    INIT: 'INIT',
    OPEN_DB: 'OPEN_DB',
    SET_DB_MANAGER: 'SET_DB_MANAGER',
    SEND_RESOURCES: 'SEND_RESOURCES',
    SEND_TRACE: 'SEND_TRACE',
    DOWNLOAD_SYNC_FILE: 'DOWNLOAD_SYNC_FILE',
    SYNCH: 'SYNCH'
  },
  USER_CREDENTIALS:"user_credentials",
  PREFERENCES:"preferences",
  UUID:"uuid",
  YES:"y",
  NO:"n",
  REPORT_N_OF_PAGE: -1,
  REPORT_RANGE: "",
  REPORT_START_DATE: ""
}

interface LOGIN_METHOD {
  ONLINE: string;
  CORDOVA: string;
}

interface EVENTS {
  LOGIN: string;
  INIT: string;
  OPEN_DB: string;
  SET_DB_MANAGER: string;
  SEND_RESOURCES: string;
  SEND_TRACE: string;
  DOWNLOAD_SYNC_FILE: string;
  SYNCH: string;
}
